module.exports = __webpack_public_path__ + "bbc69dbbf120b60d809d60ac6dc92446.svg";